import { useGlossaries } from "store/glossary/glossary.store";

export const useGlossarySearchQuery = (): string =>
  useGlossaries<string>((state) => state.searchQuery);
